import axios from 'axios';
import '../utils/retryMechanism/retrySessionInterface';
import { useSessionStore } from 'stores';

// Add axios request interceptor to automatically use token from sessionStore
axios.interceptors.request.use(
  config => {
    // Get the latest token from session store
    const sessionStore = useSessionStore.getState();
    const { token } = sessionStore;

    // Only modify config if we have a token in session
    if (token) {
      config.headers.set('Authorization', `Bearer ${token}`);
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// eslint-disable-next-line import/prefer-default-export
export const setHeaders = (
  token: string,
  platform: string,
  version: string,
  language: string
) => {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  axios.defaults.headers.common['Accept'] = 'application/json';
  axios.defaults.headers.common['Content-Type'] = 'application/json';
  axios.defaults.headers.common['platform'] = platform;
  axios.defaults.headers.common['X-APP-VERSION'] = version;
  axios.defaults.headers.common['Accept-Language'] = language;
  axios.defaults.withCredentials = true;
};
